import { Component, Input } from '@angular/core';
import { NavItem } from '../sidebar.component';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  standalone: false
})
export class NavItemComponent {
  @Input() public item: NavItem;
  @Input() public compact: boolean;

  public canShowParent(item: NavItem): boolean {
    return item.canShow() && item.children.some(child => child.canShow());
  }
}
